'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AttributionViews } from 'AdsUI/lib/Constants';
import { changeFilters } from 'AdsUI/actions/GlobalFilterActions';
import AttributionViewSelect from 'AdsUI/components/AttributionViewSelect';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import { hasAccessToMultiAttribution } from 'AdsUI/selectors/AuthSelectors';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
const ALL_ATTRIBUTION_VIEWS = [AttributionViews.FIRST_WEB_SESSION, AttributionViews.PRE_CONTACT_INFLUENCED, AttributionViews.FIRST_FORM_SUBMISSION, AttributionViews.ALL_FORM_SUBMISSIONS, AttributionViews.REENGAGEMENT];

const getAttributionViewsForUser = hasAllAttributionViews => {
  // Eventually we will likely want to separate out which views which person gets
  // based on tiers or some combination of Features.
  if (hasAllAttributionViews) {
    return ALL_ATTRIBUTION_VIEWS;
  } else {
    return [AttributionViews.FIRST_FORM_SUBMISSION];
  }
};

const GlobalAttributionViewFilterContainer = ({
  globalFilters,
  hasAllAttributionViews,
  dispatch
}) => {
  const attributionViewsOrder = getAttributionViewsForUser(hasAllAttributionViews);
  const lockedAttributionViews = ALL_ATTRIBUTION_VIEWS.filter(view => attributionViewsOrder.indexOf(view) === -1);
  const updateAttributionView = useCallback(({
    attributionView
  }) => {
    dispatch(changeFilters({
      attributionView
    }));
    usageTracker.track('setAttributionView', {
      attributionView
    });
  }, [dispatch]);
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.attributionViews.label"
    }),
    children: /*#__PURE__*/_jsx(AttributionViewSelect, {
      selectedView: globalFilters.attributionView,
      attributionViews: attributionViewsOrder,
      lockedAttributionViews: lockedAttributionViews,
      onChangeFilters: updateAttributionView
    })
  });
};

export default connect(state => {
  return {
    globalFilters: getGlobalFilters(state),
    hasAllAttributionViews: hasAccessToMultiAttribution(state)
  };
})(GlobalAttributionViewFilterContainer);